// extracted by mini-css-extract-plugin
export default {"background":"styles_background__FDXZD"};